import { ErrorResponse } from "../types/errorResponse";

export const shouldRetryQuery = (
  failureCount: number,
  error: ErrorResponse,
) => {
  if (error?.response?.status && error?.response?.status >= 400 && error?.response?.status < 500)
    return false

  return failureCount < 3
}
